export const PLAYER_RADAR_CHART_OPTIONS = [
  {
    label: 'Player Radar',
    value: 0,
    variant: 'Profile',
  },
  {
    label: 'League Avg. Comparison',
    value: 1,
    variant: 'Players',
  },
];
